import clsx from 'clsx'
import includes from 'lodash/includes'
import map from 'lodash/map'
import React, { useState } from 'react'

import SvgCheck from '@Assets/SVG/Check'
import SvgPlus from '@Assets/SVG/Plus'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { ProductItem } from '@Domains/Product/Components/ProductItem'
import { RecommendationContentFragment, SplitTestGroup } from '@Generated/graphql'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { Test } from '@Globals/SplitTests/types'

import styles from './SideCartRecommendationsV2.module.scss'

type Recommendations = NonNullable<RecommendationContentFragment['recommendations']>

export const SideCartRecommendationsV2 = ({
  recommendations,
}: {
  recommendations: Recommendations
}) => {
  const [addedIds, setAddedIds] = useState<string[]>([])
  return (
    <div className={clsx(styles.cartRecommendations)}>
      {map(recommendations, (recommendation) => {
        let component = (
          <div key={recommendation.id} className={styles.recommendations}>
            <div className={styles.recommendationsTitle}>{recommendation.title}</div>
            {map(recommendation?.products, product => (
              <ProductItem
                key={product.id}
                action={(
                  <BuyButtonV2
                    className={clsx(styles.AddToCartProduct, addedIds.includes(product.id) && styles.success)}
                    color="black"
                    onSuccess={() => {
                      setAddedIds(prev => [...prev, product.id])
                    }}
                    preventDefault
                    productID={product.id}
                    products={[{ quantity: 1, variantID: '', productID: product.id }]}
                    sourceID={`cart_${recommendation.id}`}
                    stopPropagation
                    useCache={false}
                    withoutSuccessPrompt
                  >
                    {!addedIds.includes(product.id) ? <SvgPlus /> : <SvgCheck />}
                  </BuyButtonV2>
                  )}
                analytics={{ source_id: `cart_${recommendation.id}` }}
                className={styles.recommendationsProduct}
                content={product.name}
                discount={product.masterVariant?.price?.discount?.format || ''}
                imageUrl={product.primaryAsset?.url || ''}
                price={product.masterVariant?.price?.format || ''}
                url={product.url || ''}
              />
            ))}
          </div>
        )
        const { splitTest } = recommendation

        if (splitTest?.test) {
          component = (
            <Experiment
              key={recommendation.id}
              a={includes(splitTest.groups, SplitTestGroup.A) ? component : undefined}
              b={includes(splitTest.groups, SplitTestGroup.B) ? component : undefined}
              c={includes(splitTest.groups, SplitTestGroup.C) ? component : undefined}
              d={includes(splitTest.groups, SplitTestGroup.D) ? component : undefined}
              test={splitTest.test as Test}
            />
          )
        }

        return component
      })}
    </div>
  )
}
